import React from "react";
import { Navigate } from "react-router-dom";

import { useHasSomeRoles } from "../../util/hooks";
import { Loading } from "../Loading";

type RedirectingStaffGuardProps = {
  element: React.ReactNode;
};

export const RedirectingStaffGuard = ({
  element,
}: RedirectingStaffGuardProps) => {
  const { data: isAdminOrStaff, isLoading } = useHasSomeRoles([
    "admin",
    "staff",
  ]);

  if (isLoading) {
    return <Loading />;
  }
  if (isAdminOrStaff) {
    return element;
  }
  return <Navigate to="/" />;
};
